import { getTriggerElementsFromElement } from '../../../libs/gin-tonic/helpers/dom/get-trigger-elements-form-element';

export class Dialog {
	triggers: HTMLElement[];
	disableClose = false;
	rect: DOMRect | null = null;
	currentTarget: HTMLElement | null = null;

	constructor(private element: HTMLDialogElement) {
		this.triggers = getTriggerElementsFromElement(this.element);

		this.triggers.forEach(trigger =>
			trigger.addEventListener('click', e => {
				this.currentTarget = e.currentTarget as HTMLElement;
				if (this.currentTarget.hasAttribute('data-align-dialog')) {
					this.currentTarget.classList.add('is-active');
					this.rect = this.currentTarget.getBoundingClientRect();
				} else {
					this.currentTarget = null;
					this.rect = null;
				}
				this.toggle();
			})
		);

		this.disableClose = this.element.hasAttribute('data-disable-close') && this.element.getAttribute('data-disable-close')?.toUpperCase() == 'TRUE';

		this.element.addEventListener('click', event => {
			if (event.target === this.element && !this.disableClose) {
				this.close();
			}
		});

		this.element.addEventListener('op10.open', () => {
			if (!this.element.open) {
				this.open();
			}
		});

		this.element.addEventListener('op10.close', () => {
			if (this.element.open) {
				this.close();
			}
		});
	}

	toggle() {
		if (this.element.open) {
			this.close();
		} else {
			this.open();
		}
	}

	open() {
		this.element.inert = true; // disable autofocus
		this.element.showModal();
		this.element.inert = false;

		this.addClass('is-opening');
		this.removeClass('is-closing');
		this.removeClass('is-closed');

		if (this.rect != null) {
			this.element.style.top = this.rect.bottom + 'px';
			this.element.style.left = this.rect.left + 'px';
		}

		const eventHandler = () => {
			this.removeClass('is-opening');
			this.addClass('is-open');
			this.element.dispatchEvent(new Event('op10.opened'));
			this.element.removeEventListener('animationend', eventHandler, false);
		};

		this.element.addEventListener('animationend', eventHandler, false);
	}

	close() {
		//this.addClass('is-closing');
		this.removeClass('is-opening');
		this.removeClass('is-open');
		if (this.currentTarget != null) {
			this.currentTarget.classList.remove('is-active');
		}

		this.element.close();
		this.addClass('is-closed');
		this.element.dispatchEvent(new Event('op10.closed'));

		/*const eventHandler = () => {
			this.removeClass('is-closing');
			this.element.close();
			this.addClass('is-closed');
			this.element.removeEventListener('animationend', eventHandler, false);
		};

		this.element.addEventListener('animationend', eventHandler, false);*/
	}

	addClass(...tokens: string[]) {
		this.element.classList.add(...tokens);
		this.triggers.forEach(trigger => trigger.classList.add(...tokens));
	}

	removeClass(...tokens: string[]) {
		this.element.classList.remove(...tokens);
		this.triggers.forEach(trigger => trigger.classList.remove(...tokens));
	}
}
